<div class="container-login">
  <div class="imagen-login">
    <img src="assets/images/panel-captarmedia-01.png" style="height: 200px">
  </div>

  <div *ngIf="successMessage" class="alert alert-success" role="alert">
    {{ successMessage }}
  </div>
  <div *ngIf="errorMessage" class="alert alert-danger" role="alert" style="text-align: center">
    {{ errorMessage }}
  </div>

  <div class="text-center" style="margin-top: 20px;">
    <ngx-spinner bdOpacity=0.9 bdColor="#fff" size="medium" color="#007bff" type="line-scale"></ngx-spinner>
  </div>

  <div *ngIf="activacionExitosa" class="text-center" style="margin-top: 20px;">
    <button class="button-login" (click)="irALogin()">IR A INICIAR SESIÓN</button>
  </div>

  <div *ngIf="errorMessage && !activacionExitosa" class="text-center" style="margin-top: 20px;">
    <button class="button-login" (click)="irARegistro()">IR A REGISTRO</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/activacion/activacion.component.html